import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Modal} from '@softline/ui-core';


import { FileInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'lib-retour-image-dialog',
    imports: [
    FileInputComponent,
    TranslatePipe
  ],
    templateUrl: './retour-image-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./retour-image-dialog.component.css']
})
export class RetourImageDialogComponent implements Modal<File[] | null> {

  close!: (result: File[] | null) => void;

  registerCloseHandler(handler: (result: File[] | null) => void) {
    this.close = handler;
  }
}
